import React from "react";
import { CategoryProduct } from "../../../domain/entities/CategoryProduct";
import CardProductComponents from "./CardProductComponents";
import ProductBorderLineComponents from "../productBorderLineComponents/ProductBorderLineComponents";

interface ListProductsRegisterProps {
    category: CategoryProduct;
    onProductId: (productId: number, price: number) => void;
}

const ListProductsRegister: React.FC<ListProductsRegisterProps> = ({ category, onProductId }) => {

    const handleButtonCallTeam = (productId: number, price: number) => {
        onProductId(productId, price);
    };

    const handleClickProduct = (productId: number, price: number) => {
        onProductId(productId, price);
    }
    
    let componentList;
    switch (category.slug) {
      case 'business-solutions':
        componentList = (
            <ProductBorderLineComponents 
                productItems={category.products}
                onButtonClick={handleButtonCallTeam} 
            />
        );
        break;
      default:
        componentList = (<CardProductComponents onProductId={handleClickProduct} productItems={category.products}/>);
    }

    return (
        <>
            {componentList}
        </>
    );
};

export default ListProductsRegister;